/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'contas',
        title: 'Assistente de Contas',
        type: 'basic',
        icon: 'mat_outline:support_agent',
        link: '/contas',
    },
    {
        id: 'capacitacao',
        title: 'Capacitação',
        type: 'basic',
        icon: 'mat_outline:play_circle',
        link: '/capacitacao',
    },
    {
        id: 'inadimplentes',
        title: 'Inadimplentes',
        type: 'basic',
        icon: 'mat_outline:app_blocking',
        link: '/inadimplentes',
    },
    {
        id: 'lia',
        title: 'Lentes IA',
        type: 'group',
        icon: 'mat_outline:app_blocking',
        children: [
            {
                id: 'laboratorios',
                title: 'Laboratórios',
                type: 'basic',
                icon: 'mat_outline:panorama_photosphere',
                link: '/laboratorios',
            },
        ],
    },
    {
        id: 'profile',
        title: 'Perfil',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/perfil',
    },
    {
        id: 'sair',
        title: 'Sair',
        type: 'basic',
        icon: 'heroicons_outline:logout',
        link: '/sair',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
